/** @file Compiled slot and attachment indices of a mesh target (the rig keys entities by name). */
import type { SkeletonData } from '@pose2d/core/types';
import type { Doc } from '@pose2d/format/types';
import type { MeshTarget } from './meshTarget';

/** Indices into `data.slots` and `data.attachments`. */
export interface CompiledTarget {
  slot: number;
  att: number;
}

/** The target's compiled indices, or null while the compiled rig lacks the slot or the mesh (a stale compile). */
export function compiledTarget(doc: Doc, data: SkeletonData, target: MeshTarget): CompiledTarget | null {
  const name = doc.slots[target.slot]?.name;
  const slot = name === undefined ? undefined : data.slotIndex.get(name);
  const att = data.attachmentIndex.get(target.mesh.name);
  return slot === undefined || att === undefined || data.attachments[att]?.type !== 'mesh' ? null : { slot, att };
}
